import React from 'react'
import About from './About'
import Projects from './Projects'
import TechStack from './TechStack'
import Experience from './Experience'
import Writings from './Writings'
import Contact from './Contact'

function Main() {
  return (
    <main id="main-content">
      <About />
      <section className="container">
        <Projects />
      </section>
      <section className="container mt-6">
        <TechStack />
      </section>
      <section className="container">
        <Experience />
      </section>
      <section className="container">
        <Writings />
      </section>
      <section className="container">
        <Contact />
      </section>
    </main>
  )
}

export default Main
